'use client';

import styled from '@benzinga/themetron';

export const SectionSubtitle = styled.p<{ tinted?: boolean }>`
  color: ${({ theme, tinted }) => (tinted ? theme.colors.foregroundMuted : '#000000')};
  font-size: ${({ theme }) => theme.fontSize['lg']};
`;
